/**
 * PreviewProcess — Step-by-step process grid
 */

interface ProcessStep {
  num?: string;
  title: string;
  text: string;
}

interface PreviewProcessProps {
  data: {
    title?: string;
    subtitle?: string;
    steps?: ProcessStep[];
  };
}

export function PreviewProcess({ data }: PreviewProcessProps) {
  return (
    <section className="preview-process">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div className="preview-process__grid">
          {(data.steps || []).map((s, i) => (
            <div key={i} className="preview-process__card">
              <div className="preview-process__num">
                {s.num || String(i + 1).padStart(2, "0")}
              </div>
              <div className="preview-process__title">{s.title}</div>
              <div className="preview-process__text">{s.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
